import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';

interface AvatarProps extends ComponentPropsWithoutRef<typeof AvatarPrimitive.Root> {
  fallback: string;
  src?: string;
  alt?: string;
}

export const Avatar = forwardRef<
  ElementRef<typeof AvatarPrimitive.Root>,
  AvatarProps
>(({ fallback, src, alt, className, ...props }, ref) => (
  <AvatarPrimitive.Root ref={ref} className={className} {...props}>
    {src && <AvatarPrimitive.Image src={src} alt={alt || 'User avatar'} />}
    <AvatarPrimitive.Fallback delayMs={0}>{fallback}</AvatarPrimitive.Fallback>
  </AvatarPrimitive.Root>
));

Avatar.displayName = 'Avatar';
